<template>
  <Modal
    name="UPDATE_REAL_ESTATE_USER_PASSWORD_MODAL"
    :title="$t('profile.label.updatePassword')"
    actions
  >
    <template v-slot:body>
      <v-progress-linear
        class="mt-5 mb-7"
        v-show="isLoading"
        indeterminate
        rounded
      />

      <div v-show="!isLoading">
        <v-form ref="updatePasswordForm" lazy-validation>
          <v-text-field
            v-model="currentPassword"
            :label="$t('profile.updatePassword.label.currentPassword')"
            :rules="[rules.required]"
            :append-outer-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append-outer="showPassword = !showPassword"
            :type="showPassword ? 'text' : 'password'"
            outlined
          />
          <v-text-field
            v-model="newPassword"
            :label="$t('profile.updatePassword.label.newPassword')"
            :rules="[rules.required, rules.differentFromCurrentPassword]"
            :append-outer-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append-outer="showPassword = !showPassword"
            :type="showPassword ? 'text' : 'password'"
            outlined
          />
          <v-text-field
            v-model="repeatedNewPassword"
            :label="$t('profile.updatePassword.label.repeatNewPassword')"
            :rules="[rules.required, rules.sameAs, rules.differentFromCurrentPassword]"
            :append-outer-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append-outer="showPassword = !showPassword"
            :type="showPassword ? 'text' : 'password'"
            outlined
          />
        </v-form>
      </div>
    </template>
    <template v-slot:actions>
        <v-btn
        @click="closeAllModals"
        :loading="isLoading"
        elevation="0"
        class="mr-5"
        large
        text
      >
        {{ $t('profile.updatePassword.label.cancel') }}
      </v-btn>

      <v-btn
        @click="validate"
        :loading="isLoading"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('profile.updatePassword.label.confirm') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { required } from '@/util/errorHandling'
import Modal from '@/components/app/Modal'
import HostSelect from '@/components/host/HostSelect'

export default {
  name: 'UpdatePassword',
  components: {
    Modal,
    HostSelect
  },
  data() {
    return {
      currentPassword: null,
      newPassword: null,
      repeatedNewPassword: null,
      rules: {
        required,
        sameAs: v => v === this.newPassword || "As senhas não conferem",
        differentFromCurrentPassword: v => v !== this.currentPassword || "Não pode ser igual a senha atual"
      },
      showPassword: false,
    }
  },
  computed: {
    ...mapGetters(['appointment', 'isLoading']),
  },
  methods: {
    ...mapActions(['updateRealEstateUserPassword']),
    ...mapMutations(['closeAllModals']),

    validate() {
      if (this.$refs.updatePasswordForm.validate() && this.newPassword == this.repeatedNewPassword) {
        const body = {
          current_password: this.currentPassword,
          new_password: this.newPassword
        }
        this.updateRealEstateUserPassword(body)
      }
    },
  },
}
</script>
  